import React, { useState, useEffect, useRef, useCallback } from 'react';
import { heroImages } from '../assets/images';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [textAnimationClass, setTextAnimationClass] = useState('active');
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const carouselRef = useRef(null);

  const heroTexts = [
    {
      id: 1,
      text: "En este espacio floral encontrarás plantas, flores y mucho más, pero sobre todo encontrarás felicidad",
      isQuote: false
    },
    {
      id: 2,
      text: "En Flores de Lis Barcelona queremos que te sientas libre a la hora de elegir y crear con la naturaleza",
      isQuote: false
    },
    {
      id: 3,
      text: "Queremos que reconectes con la naturaleza, con sus olores, colores y texturas",
      isQuote: false
    },
    {
      id: 4,
      text: "Vive la naturaleza, siéntela y fúndete con ella para que juntas creemos algo especial, un arreglo floral o la celebración perfecta que estabas buscando",
      isQuote: false
    },
    {
      id: 5,
      text: "No solo somos una floristería, también somos un taller floral. Te invitamos a que vengas a vivir la experiencia con tus personas favoritas",
      isQuote: false
    }
  ];

  const goToNext = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    
    // Iniciar animación de salida del texto simultáneamente con la imagen
    setTextAnimationClass('exiting');
    
    // Cambiar imagen inmediatamente para comenzar transición visual
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
      setTextAnimationClass('entering');
    }, 50);
    
    // Activar texto y finalizar transición después de que las animaciones terminen
    setTimeout(() => {
      setTextAnimationClass('active');
      setIsTransitioning(false);
    }, 800);
  }, [isTransitioning]);

  const goToPrevious = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    
    // Iniciar animación de salida del texto simultáneamente con la imagen
    setTextAnimationClass('exiting');
    
    // Cambiar imagen inmediatamente para comenzar transición visual
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === 0 ? heroImages.length - 1 : prevIndex - 1
      );
      setTextAnimationClass('entering');
    }, 50);
    
    // Activar texto y finalizar transición después de que las animaciones terminen
    setTimeout(() => {
      setTextAnimationClass('active');
      setIsTransitioning(false);
    }, 800);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!touchStartX.current || !touchEndX.current) return;
    
    const distance = touchStartX.current - touchEndX.current;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      goToNext();
    }
    if (isRightSwipe) {
      goToPrevious();
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 5000); // Cambia cada 5 segundos

    return () => clearInterval(interval);
  }, [goToNext]);

  return (
    <section id="home" className="hero">
      <div 
        className="hero-carousel"
        ref={carouselRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {heroImages.map((image, index) => {
          let slideClass = 'hero-slide';
          
          if (index === currentImageIndex) {
            slideClass += ' active';
          } else if (index === (currentImageIndex - 1 + heroImages.length) % heroImages.length) {
            slideClass += ' prev';
          } else if (index === (currentImageIndex + 1) % heroImages.length) {
            slideClass += ' next';
          }

          if (isTransitioning) {
            slideClass += ' transitioning';
          }

          return (
            <div
              key={image.id}
              className={slideClass}
              style={{
                backgroundImage: `url(${image.url})`,
              }}
            />
          );
        })}
        <div className="hero-overlay"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <h1>Flores de Lis Barcelona</h1>
          <div className="hero-text">
            <div className={`hero-text-content ${textAnimationClass}`}>
              {heroTexts[currentImageIndex].isQuote ? (
                <blockquote>
                  <p>"{heroTexts[currentImageIndex].text}"</p>
                  <cite>({heroTexts[currentImageIndex].author})</cite>
                </blockquote>
              ) : (
                <p>{heroTexts[currentImageIndex].text}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
